export default "__VITE_ASSET__ai7BogjB__"